import React, { useState, useEffect, useRef } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Card, Form, Button, Row, Col, Modal, Tabs, Tab } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import { API_URL_LOCAL } from "..";
import { Icon } from "@iconify/react/dist/iconify.js";
import swal from "sweetalert";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";

const RequestsPage = () => {
  const [activeTab, setActiveTab] = useState("loan");
  const [requests, setRequests] = useState({ loans: [], advanceSalaries: [], allowances: [] });
  const [employees, setEmployees] = useState([]);
  const [currencies, setCurrencies] = useState([
    { value: "USD", label: "USD" },
    { value: "PKR", label: "PKR" },
    { value: "EUR", label: "EUR" },
    { value: "GBP", label: "GBP" },
    { value: "INR", label: "INR" },
  ]);
  const [allowanceTypes, setAllowanceTypes] = useState([
    { value: "Housing", label: "Housing" },
    { value: "Transport", label: "Transport" },
    { value: "Meal", label: "Meal" },
    { value: "Medical", label: "Medical" },
    { value: "Education", label: "Education" },
    { value: "Travel", label: "Travel" },
    { value: "Performance", label: "Performance" },
    { value: "Overtime", label: "Overtime" },
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    id: null,
    employee_id: null,
    amount: "",
    currency: null,
    issue_date: "",
    comments: "",
    type: null, // Allowance
    include: "Once", // Allowance
    option: "Addon", // Allowance
    frequency: "Fixed", // Allowance
  });
  const [isEdit, setIsEdit] = useState(false);
  const tableRef = useRef(null);

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.id) throw new Error("User not found in localStorage");

        // Fetch employees
        const empResponse = await axios.get(`${API_URL_LOCAL}/api/employee/fetch/${user?.id}`);
        const empData = empResponse.data.employees.map((emp) => ({
          value: emp.id,
          label: `${emp.first_name} ${emp.last_name}`,
        }));
        setEmployees(empData);

        // Fetch requests
        const [loanResponse, advanceResponse, allowanceResponse] = await Promise.all([
          axios.get(`${API_URL_LOCAL}/api/requests/loans/${user.id}`),
          axios.get(`${API_URL_LOCAL}/api/requests/advance-salaries/${user.id}`),
          axios.get(`${API_URL_LOCAL}/api/requests/allowances/${user.id}`),
        ]);
        setRequests({
          loans: loanResponse.data.loans || [],
          advanceSalaries: advanceResponse.data.advanceSalaries || [],
          allowances: allowanceResponse.data || [],
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (!loading && tableRef.current) {
      const data = activeTab === "loan"
        ? requests.loans
        : activeTab === "advance-salary"
        ? requests.advanceSalaries
        : requests.allowances;

      const columns = activeTab === "allowance"
        ? [
            { data: "employee", title: "Employee" ,render: (data) => data?.first_name, },
            { data: "type", title: "Type" },
            { data: "amount", title: "Amount" },
            { data: "currency", title: "Currency" },
            { data: "include_type", title: "Include" },
            { data: "option", title: "Option" },
            { data: "frequency", title: "Frequency" },
            {
              data: "issue_date",
              title: "Issue Date",
              render: (data) => new Date(data).toLocaleDateString(),
            },
            {
              data: "status_for",
              title: "Status",
              render: (data) => {
                const className =
                  data === "Approved"
                    ? "bg-success-50 text-success-600 border-success-50"
                    : data === "Declined"
                    ? "bg-danger-50 text-danger-600 border-danger-50"
                    : "bg-warning-50 text-warning-600 border-warning-50";
                return `<span class="badge ${className}">${data}</span>`;
              },
            },
            {
              data: null,
              title: "Action",
              orderable: false,
              render: (data, type, row) => {
                let buttons = `
                  <div class="d-flex gap-2">
                    <button class="btn btn-outline-primary px-8 py-4 radius-8 edit-btn" data-id="${row.id}">
                      <i class="ph ph-pencil" style="font-size: 18px;"></i>
                    </button>
                    <button class="btn btn-outline-danger px-8 py-4 radius-8 delete-btn" data-id="${row.id}">
                      <i class="ph ph-trash" style="font-size: 18px;"></i>
                    </button>
                `;
                if (row.status_for == "Pending" || row.status_for == "pending") {
                  buttons += `
                    <button class="btn btn-outline-success px-8 py-4 radius-8 approve-btn" data-id="${row.id}">
                      <i class="ph ph-check" style="font-size: 18px;"></i>
                    </button>
                    <button class="btn btn-outline-danger px-8 py-4 radius-8 decline-btn" data-id="${row.id}">
                      <i class="ph ph-x" style="font-size: 18px;"></i>
                    </button>
                  `;
                }
                buttons += `</div>`;
                return buttons;
              },
            },
          ]
        : activeTab === 'loan' ?
        [
          { data: "employee", title: "Employee" , render: (data) => data?.first_name,},
          { data: "amount", title: "Amount" },
          { data: "currency", title: "Currency" },
          {
            data: "issue_date",
            title: "Issue Date",
            render: (data) => new Date(data).toLocaleDateString(),
          },
          { data: "comments", title: "Comments" },
          {
            data: "status_for",
            title: "Status",
            render: (data) => {
              const className =
                data === "Approved"
                  ? "bg-success-50 text-success-600 border-success-50"
                  : data === "Declined"
                  ? "bg-danger-50 text-danger-600 border-danger-50"
                  : "bg-warning-50 text-warning-600 border-warning-50";
              return `<span class="badge ${className}">${data}</span>`;
            },
          },
          {
            data: null,
            title: "Action",
            orderable: false,
            render: (data, type, row) => {
              let buttons = `
                <div class="d-flex gap-2">
                  <button class="btn btn-outline-primary px-8 py-4 radius-8 edit-btn" data-id="${row.id}">
                    <i class="ph ph-pencil" style="font-size: 18px;"></i>
                  </button>
                  <button class="btn btn-outline-danger px-8 py-4 radius-8 delete-btn" data-id="${row.id}">
                    <i class="ph ph-trash" style="font-size: 18px;"></i>
                  </button>
              `;
              if (row.status_for === "Pending" || row.status_for === "pending") {
                buttons += `
                  <button class="btn btn-outline-success px-8 py-4 radius-8 approve-btn" data-id="${row.id}">
                    <i class="ph ph-check" style="font-size: 18px;"></i>
                  </button>
                  <button class="btn btn-outline-danger px-8 py-4 radius-8 decline-btn" data-id="${row.id}">
                    <i class="ph ph-x" style="font-size: 18px;"></i>
                  </button>
                `;
              }
              buttons += `</div>`;
              return buttons;
            },
          },
        ]:
        [
          { data: "employee", title: "Employee" , render: (data) => data?.first_name,},
          { data: "amount", title: "Amount" },
          { data: "currency", title: "Currency" },
          {
            data: "issue_date",
            title: "Issue Date",
            render: (data) => new Date(data).toLocaleDateString(),
          },
          { data: "comments", title: "Comments" },
          {
            data: "status_for",
            title: "Status",
            render: (data) => {
              const className =
                data === "Approved"
                  ? "bg-success-50 text-success-600 border-success-50"
                  : data === "Declined"
                  ? "bg-danger-50 text-danger-600 border-danger-50"
                  : "bg-warning-50 text-warning-600 border-warning-50";
              return `<span class="badge ${className}">${data}</span>`;
            },
          },
          {
            data: null,
            title: "Action",
            orderable: false,
            render: (data, type, row) => {
              let buttons = `
                <div class="d-flex gap-2">
                  <button class="btn btn-outline-primary px-8 py-4 radius-8 edit-btn" data-id="${row.id}">
                    <i class="ph ph-pencil" style="font-size: 18px;"></i>
                  </button>
                  <button class="btn btn-outline-danger px-8 py-4 radius-8 delete-btn" data-id="${row.id}">
                    <i class="ph ph-trash" style="font-size: 18px;"></i>
                  </button>
              `;
              if (row.status_for === "Pending" || row.status_for === "pending") {
                buttons += `
                  <button class="btn btn-outline-success px-8 py-4 radius-8 approve-btn" data-id="${row.id}">
                    <i class="ph ph-check" style="font-size: 18px;"></i>
                  </button>
                  <button class="btn btn-outline-danger px-8 py-4 radius-8 decline-btn" data-id="${row.id}">
                    <i class="ph ph-x" style="font-size: 18px;"></i>
                  </button>
                `;
              }
              buttons += `</div>`;
              return buttons;
            },
          },
        ];

      const table = $(tableRef.current).DataTable({
        data,
        columns,
        responsive: true,
        pageLength: 10,
        lengthMenu: [10, 20, 50],
        order: [[activeTab === "allowance" ? 7 : 3, "desc"]], // Issue Date
        language: {
          emptyTable: `No ${activeTab.replace("-", " ")} requests found`,
        },
        destroy: true,
      });

      // Handle button clicks
      $(tableRef.current).on("click", ".edit-btn", function () {
        const id = $(this).data("id");
        const request = data.find((r) => r.id === id);
        openModal(request);
      });

      $(tableRef.current).on("click", ".delete-btn", function () {
        const id = $(this).data("id");
        handleDeleteRequest(id);
      });

      $(tableRef.current).on("click", ".approve-btn", function () {
        const id = $(this).data("id");
        handleStatusChange(id, "Approved");
      });

      $(tableRef.current).on("click", ".decline-btn", function () {

        const id = $(this).data("id");
        handleStatusChange(id, "Declined");
      });

      // Cleanup
      return () => {
        table.destroy();
        $(tableRef.current).off("click");
      };
    }
  }, [requests, activeTab, loading]);

  // Handle modal input changes
  const handleModalChange = (field, value) => {
    setModalData({ ...modalData, [field]: value });
  };

  // Open modal for add/edit
  const openModal = (request = null) => {
    if (request) {
      console.log(request)
      setModalData({
        id: request.id,
        employee_id: employees.find((e) => e.value === request.employee.id) || null,
        amount: request.amount.toString(),
        currency: activeTab === "loan"
          ? request.currency
          : currencies.find((c) => c.value === request.currency) || null,
        issue_date: request.issue_date.split("T")[0],
        comments: request.comments || "",
        type: activeTab === "allowance"
          ? allowanceTypes.find((t) => t.value === request.type) || null
          : null,
        include: request.include_type || "Once",
        option: request.option || "Addon",
        frequency: request.frequency || "Fixed",
      });
      setIsEdit(true);
    } else {
      setModalData({
        id: null,
        employee_id: null,
        amount: "",
        currency: activeTab === "loan" ? "" : null,
        issue_date: "",
        comments: "",
        type: null,
        include: "Once",
        option: "Addon",
        frequency: "Fixed",
      });
      setIsEdit(false);
    }
    setShowModal(true);
  };

  // Save request
  const handleSaveRequest = async () => {
    try {
      const requiredFields = ["employee_id", "amount", "issue_date"];
      if (activeTab !== "loan") requiredFields.push("currency");
      if (activeTab === "allowance") requiredFields.push("type");
      for (const field of requiredFields) {
        
        if (!modalData[field] || (field === "amount" && modalData[field] <= 0)) {
          alert("Please fill all required fields with valid values");
          return;
        }
      }

      const payload = {
        employee_id: modalData.employee_id.value,
        amount: parseFloat(modalData.amount),
        currency: activeTab === "loan" ? modalData.currency : modalData.currency.value,
        issue_date: modalData.issue_date,
        comments: modalData.comments,
      };
      if (activeTab === "allowance") {
        payload.type = modalData.type.value;
        payload.include_type = modalData.include;
        payload.option = modalData.option;
        payload.frequency = modalData.frequency;
      }
      const user = JSON.parse(localStorage.getItem('user'));
    payload.org_id = user.id
      let response;
      const endpoint = activeTab === "loan"
        ? "loan"
        : activeTab === "advance-salary"
        ? "advance-salary"
        : "allowance";
      if (isEdit) {
        response = await axios.put(
          `${API_URL_LOCAL}/api/requests/${endpoint}/${modalData.id}`,
          payload
        );
      } else {
        response = await axios.post(`${API_URL_LOCAL}/api/requests/${endpoint}`, payload);
      }

      if (response.status === 200 || response.status === 201) {
        const updatedRequest = {
          ...payload,
          id: response.data.id,
          employee: response.data.employee,
          status_for: response.data.status_for,
        };
        if (activeTab !== "allowance") delete updatedRequest.type;
        const passed = activeTab === 'allowance' ?  'allowances' : activeTab ==='loan' ? 'loans' : activeTab === 'advance-salary' ? "advanceSalaries" : null;
        setRequests({
          ...requests,
          [passed]:
           isEdit
            ? requests[passed].map((r) => (r.id === modalData.id ? updatedRequest : r))
            : [...requests[passed], updatedRequest],
        });
        setShowModal(false);
        swal(`${activeTab.replace("-", " ")}`,`${activeTab.replace("-", " ")} request ${isEdit ? "updated" : "created"} successfully!`, "success");
      }
    } catch (err) {
      alert(`Failed to ${isEdit ? "update" : "create"} ${activeTab.replace("-", " ")} request: ${err.message}`);
    }
  };

  // Delete request
  const handleDeleteRequest = (id) => {
    swal({
      title: "Are you sure?",
      text: `You want to delete this ${activeTab.replace("-", " ")} request?`,
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const endpoint = activeTab === "loan"
            ? "loan"
            : activeTab === "advance-salary"
            ? "advance-salary"
            : "allowance";
          const response = await axios.delete(
            `${API_URL_LOCAL}/api/requests/${endpoint}/${id}`
          );
          if (response.status === 200) {
            const passed = activeTab === 'allowance' ?  'allowances' : activeTab ==='loan' ? 'loans' : activeTab === 'advance-salary' ? "advanceSalaries" : null;
            setRequests({
              ...requests,
              [passed]: requests[passed].filter((r) => r.id !== id),
            });
            swal("Success", `${activeTab.replace("-", " ")} request deleted successfully!`, "success");
          } else {
            throw new Error(`Failed to delete ${activeTab.replace("-", " ")} request`);
          }
        } catch (err) {
          swal("Error", `Failed to delete ${activeTab.replace("-", " ")} request: ${err.message}`, "error");
        }
      }
    });
  };

  // Approve/Decline request
  const handleStatusChange = async (id, status_for) => {
    try {
      const endpoint = activeTab === "loan"
        ? "loan"
        : activeTab === "advance-salary"
        ? "advance-salary"
        : "allowance";
      const response = await axios.put(
        `${API_URL_LOCAL}/api/requests/${endpoint}/${id}`,
        { status_for }
      );
      if (response.status === 201 || response.status === 200) {
        const passed = activeTab === 'allowance' ?  'allowances' : activeTab ==='loan' ? 'loans' : activeTab === 'advance-salary' ? "advanceSalaries" : null;
        setRequests({
          ...requests,
          [passed]: requests[passed].map((r) =>
            r.id === id ? { ...r, status_for } : r
          ),
        });
        swal("Status Update",`${activeTab.replace("-", " ")} request ${status_for.toLowerCase()} successfully!`, "success");
      } else {
        throw new Error(`Failed to ${status_for.toLowerCase()} ${activeTab.replace("-", " ")} request`);
      }
    } catch (err) {
      alert(`Failed to ${status_for.toLowerCase()} ${activeTab.replace("-", " ")} request: ${err.message}`);
    }
  };

//   if (loading) return <div className="text-center">Loading...</div>;
  if (error)
    return (
      <div className="alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-20 fw-semibold text-lg radius-8">
        {error}
      </div>
    );

  return (
    <MasterLayout>
      <Breadcrumb title="Requests" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-20"
          >
            <Tab eventKey="loan" title="Loan" />
            <Tab eventKey="advance-salary" title="Advance Salary" />
            <Tab eventKey="allowance" title="Allowance" />
          </Tabs>
          <div className="d-flex justify-content-between mb-20">
            <h4 className="fw-semibold text-primary-dark">
              {activeTab === "loan"
                ? "Loan Requests"
                : activeTab === "advance-salary"
                ? "Advance Salary Requests"
                : "Allowance Requests"}
            </h4>
            <Button
              variant="primary"
              className="text-md px-24 py-8 radius-8"
              onClick={() => openModal()}
            >
              <Icon fontSize={22} icon="mdi:plus" className="me-2" />
              {activeTab === "loan"
                ? "Add Loan"
                : activeTab === "advance-salary"
                ? "Add Advance Salary"
                : "Add Allowance"}
            </Button>
          </div>
          <div className="table-responsive">
            <table
              id="requests-table"
              ref={tableRef}
              className="table table-striped table-bordered"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Employee</th>
                  {activeTab === "allowance" && <th>Type</th>}
                  <th>Amount</th>
                  <th>Currency</th>
                  {activeTab === "allowance" && <th>Include</th>}
                  {activeTab === "allowance" && <th>Option</th>}
                  {activeTab === "allowance" && <th>Frequency</th>}
                  <th>Issue Date</th>
                  {activeTab !== "allowance" && <th>Comments</th>}
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Request Modal */}
      <Modal style={{ zIndex: 9999 }} show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>
              <Icon fontSize={22} icon="mdi:form-select" className="me-2" />
              {isEdit
                ? `Edit ${activeTab.replace("-", " ")} Request`
                : `Add ${activeTab.replace("-", " ")} Request`}
            </h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                <Icon fontSize={22} icon="mdi:account" className="me-2" />
                Employee
              </Form.Label>
              <Select
                options={employees}
                value={modalData.employee_id}
                onChange={(selected) => handleModalChange("employee_id", selected)}
                placeholder="Select Employee"
                isDisabled={isEdit}
              />
            </Form.Group>
            {activeTab === "allowance" && (
              <Form.Group className="mb-20">
                <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                  <Icon fontSize={22} icon="mdi:tag" className="me-2" />
                  Allowance Type
                </Form.Label>
                <Select
                  options={allowanceTypes}
                  value={modalData.type}
                  onChange={(selected) => handleModalChange("type", selected)}
                  placeholder="Select Allowance Type"
                />
              </Form.Group>
            )}
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                <Icon fontSize={22} icon="mdi:cash" className="me-2" />
                Amount
              </Form.Label>
              <Form.Control
                type="number"
                min="0"
                step="0.01"
                value={modalData.amount}
                onChange={(e) => handleModalChange("amount", e.target.value)}
                className="radius-8"
                placeholder="Enter amount"
              />
            </Form.Group>
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                <Icon fontSize={22} icon="mdi:currency-usd" className="me-2" />
                Currency
              </Form.Label>
              {activeTab === "loan" ? (
                <Form.Control
                  type="text"
                  value={modalData.currency}
                  onChange={(e) => handleModalChange("currency", e.target.value)}
                  className="radius-8"
                  placeholder="e.g., USD"
                />
              ) : (
                <Select
                  options={currencies}
                  value={modalData.currency}
                  onChange={(selected) => handleModalChange("currency", selected)}
                  placeholder="Select Currency"
                />
              )}
            </Form.Group>
            {activeTab === "allowance" && (
              <>
                <Form.Group className="mb-20">
                  <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                    <Icon fontSize={22} icon="mdi:calendar-repeat" className="me-2" />
                    Include
                  </Form.Label>
                  <div className="d-flex gap-3 check-custom">
                    <Form.Check
                      type="radio"
                      label="Once"
                      name="include"
                      value="Once"
                      checked={modalData.include === "Once"}
                      onChange={(e) => handleModalChange("include", e.target.value)}
                    />
                    <Form.Check
                      type="radio"
                      label="Per Month"
                      name="include"
                      value="Per Month"
                      checked={modalData.include === "Per Month"}
                      onChange={(e) => handleModalChange("include", e.target.value)}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-20">
                  <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                    <Icon fontSize={22} icon="mdi:plus-minus" className="me-2" />
                    Option
                  </Form.Label>
                  <div className="d-flex gap-3 check-custom">
                    <Form.Check
                      type="radio"
                      label="Addon"
                      name="option"
                      value="Addon"
                      checked={modalData.option === "Addon"}
                      onChange={(e) => handleModalChange("option", e.target.value)}
                    />
                    <Form.Check
                      type="radio"
                      label="Deduct"
                      name="option"
                      value="Deduct"
                      checked={modalData.option === "Deduct"}
                      onChange={(e) => handleModalChange("option", e.target.value)}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-20">
                  <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                    <Icon fontSize={22} icon="mdi:clock" className="me-2" />
                    Frequency
                  </Form.Label>
                  <div className="d-flex gap-3 check-custom">
                    <Form.Check
                      type="radio"
                      label="Fixed"
                      name="frequency"
                      value="Fixed"
                      checked={modalData.frequency === "Fixed"}
                      onChange={(e) => handleModalChange("frequency", e.target.value)}
                    />
                    <Form.Check
                      type="radio"
                      label="Schedule"
                      name="frequency"
                      value="Schedule"
                      checked={modalData.frequency === "Schedule"}
                      onChange={(e) => handleModalChange("frequency", e.target.value)}
                    />
                  </div>
                </Form.Group>
              </>
            )}
            <Form.Group className="mb-20">
              <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                <Icon fontSize={22} icon="mdi:calendar" className="me-2" />
                Issue Date
              </Form.Label>
              <Form.Control
                type="date"
                value={modalData.issue_date}
                onChange={(e) => handleModalChange("issue_date", e.target.value)}
                className="radius-8"
              />
            </Form.Group>
            {activeTab !== "allowance" && (
              <Form.Group className="mb-20">
                <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                  <Icon fontSize={22} icon="mdi:comment" className="me-2" />
                  Comments
                </Form.Label>
                <Form.Control
                  as="textarea"
                  value={modalData.comments}
                  onChange={(e) => handleModalChange("comments", e.target.value)}
                  className="radius-8"
                  rows={4}
                  placeholder="Enter comments"
                />
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="text-md px-24 py-8 radius-8"
            onClick={() => setShowModal(false)}
          >
            <Icon fontSize={22} icon="mdi:close" className="me-2" />
            Cancel
          </Button>
          <Button
            variant="primary"
            className="text-md px-24 py-8 radius-8"
            onClick={handleSaveRequest}
          >
            <Icon fontSize={22} icon="mdi:content-save" className="me-2" />
            {isEdit ? "Update" : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </MasterLayout>
  );
};

export default RequestsPage;